// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"SucursalEdit_spinnerContainer__a8km5"};